import { Component, Input } from '@angular/core';
import { SharedThreatsComponent } from '../../../../../../../shared-components/shared-threats/shared-threats.component';

@Component({
  selector: 'app-threat-group-threats',
  templateUrl: './threat-group-threats.component.html',
  styleUrls: ['./threat-group-threats.component.scss'],
  imports: [SharedThreatsComponent],
})
export class ThreatGroupThreatsComponent {
  _threats: any[] = [];

  get threats() {
    return this._threats;
  }

  @Input() set threats(value: any[]) {
    this._threats = value.map((item) => ({ ...item, updatableStatus: item.status, updatableIsTruePositive: item.is_true_positive })) || [];
  }
}
